// extracted by mini-css-extract-plugin
export var calendarView = "_ot-0";